const DEFAULT_PUBLIC_API_BASE = 'https://controle-glace.vercel.app/api/public';

const normalizedEnvValue = (value) => String(value || '').trim();

const publicApiBase =
  normalizedEnvValue(process.env.REACT_APP_PUBLIC_API_BASE) || DEFAULT_PUBLIC_API_BASE;

export const menuApiUrl =
  normalizedEnvValue(process.env.REACT_APP_MENU_API_URL) || `${publicApiBase}/v1/menu`;

export const ordersApiUrl =
  normalizedEnvValue(process.env.REACT_APP_ORDERS_API_URL) || `${publicApiBase}/v1/orders`;

export const publicExperienceApiUrl =
  normalizedEnvValue(process.env.REACT_APP_PUBLIC_EXPERIENCE_API_URL) ||
  `${publicApiBase}/v1/experience`;
